import { BrowserProvider } from 'ethers';
import { useConnection } from 'modules/auth';
import { useEffect, useState } from 'react';
import { VaultProvider } from '../sdk/VaultProvider';
import { DEFAULT_VAULT_CHAIN_ID } from 'modules/common/const';

export const useVaultProvider = () => {
  const { isConnected, chainId } = useConnection();
  const [provider, setProvider] = useState<BrowserProvider | null>(null);
  const [readProvider, setReadProvider] = useState<BrowserProvider | null>(
    null,
  );

  useEffect(() => {
    const initProvider = async () => {
      if (isConnected) {
        const provider = await VaultProvider.getWriteInstance(true);

        setProvider(provider);
      } else {
        const provider = await VaultProvider.getReadInstance(
          false,
          DEFAULT_VAULT_CHAIN_ID,
        );
        setReadProvider(provider);
      }
    };

    initProvider();
  }, [isConnected, chainId]);

  return { provider, readProvider };
};
